import styled, { css } from 'styled-components/macro';

export const TooltipInner = styled.div.attrs({
  className: 'tooltip-inner caption-13',
})`
  z-index: 3000 !important;
  opacity: 1 !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px); /* чтоб сафари не выпендривался */

  ${({ theme }) => css`
    color: ${theme.colors.white};
  `}
`;
